var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4229 8.20001C13.0089 8.20001 12.6729 7.86401 12.6729 7.45001V5.30301C12.6729 3.20701 10.9679 1.50201 8.87188 1.50201H8.85588C7.84288 1.50201 6.89388 1.89201 6.17688 2.60301C5.45488 3.31701 5.05588 4.27001 5.05188 5.28601V7.45001C5.05188 7.86401 4.71588 8.20001 4.30188 8.20001C3.88788 8.20001 3.55188 7.86401 3.55188 7.45001V5.30301C3.55788 3.86301 4.11488 2.53401 5.11988 1.53801C6.12588 0.541011 7.45388 -0.0359891 8.87488 0.00201091C11.7949 0.00201091 14.1729 2.38001 14.1729 5.30301V7.45001C14.1729 7.86401 13.8369 8.20001 13.4229 8.20001Z",
    fill: "#BABABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.042 8.12878C3.364 8.12878 2 9.49278 2 11.1708V15.4598C2 17.1378 3.364 18.5018 5.042 18.5018H12.683C14.36 18.5018 15.725 17.1378 15.725 15.4598V11.1708C15.725 9.49278 14.36 8.12878 12.683 8.12878H5.042ZM12.683 20.0018H5.042C2.537 20.0018 0.5 17.9648 0.5 15.4598V11.1708C0.5 8.66578 2.537 6.62878 5.042 6.62878H12.683C15.188 6.62878 17.225 8.66578 17.225 11.1708V15.4598C17.225 17.9648 15.188 20.0018 12.683 20.0018Z",
    fill: "#BABABA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8623 15.1756C8.4483 15.1756 8.1123 14.8396 8.1123 14.4256V12.2046C8.1123 11.7906 8.4483 11.4546 8.8623 11.4546C9.2763 11.4546 9.6123 11.7906 9.6123 12.2046V14.4256C9.6123 14.8396 9.2763 15.1756 8.8623 15.1756Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOutlined);
export default __webpack_public_path__ + "static/media/lock-outlined.10c34b0db003c121f7ed175bc7e48d68.svg";
export { ForwardRef as ReactComponent };